import { useEffect } from 'react'

import { KeySet } from '@eastcoal/common/types/utilities'

import { useCertificationsStoreApi } from '../hooks/useStore'
import { CertificationsStore } from '../store/interface'

import { CertificationsStoreUpdaterProps } from './interface'

const useStoreUpdater = <K extends KeySet<CertificationsStore>>(
  key: K,
  value: CertificationsStore[K]
) => {
  const { setState } = useCertificationsStoreApi()

  useEffect(() => {
    setState({ [key]: value })
  }, [key, value, setState])
}

export const CertificationsStoreUpdater = ({
  value,
  onChange
}: CertificationsStoreUpdaterProps) => {
  useStoreUpdater('value', value)
  useStoreUpdater('onChange', onChange)
  return null
}
